import cubejs from '@cubejs-client/core';

export const createCubejsApi = token => cubejs(token, {
  apiUrl: 'https://steady-touchet.aws-us-east-1.cubecloudapp.dev/cubejs-api/v1',
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
